






























































































import genres, {Genres} from '../data/genres';
import Vue from 'vue';
import SearchFilter, {SearchOrder} from '@/types/SearchFilter';
import SubmissionItem from '@/components/SubmissionItem.vue';
import Favorite from '@/components/types/Favorite';
import {SubmissionId} from '@/types/Submission';

enum State {
    Searching = 'Searching',
    Searched = 'Searched',
}

interface Model {
    name: string;
    genre: string;
    onlyFavorites: boolean;
    searchOrder: SearchOrder;
}

export default Vue.extend({
    name: 'search-submissions',

    components: { SubmissionItem },

    data() : {
        state: State,
        genres: Genres,
        model: Model,
    } {
        return {
            state: State.Searching,
            genres,
            model: { name: '', genre: '', onlyFavorites: false, searchOrder: SearchOrder.Favorites },
        };
    },

    computed: {
        favoritesTitle() : string | undefined {
            if (!this.$store.state.user.loggedIn)
                return 'Log in to be able to filter by your favorites.';
            return undefined;
        },
    },

    methods: {
        searchFilter() : SearchFilter {
            const partialName = (this.model.name === '' ? undefined : this.model.name);
            const genre = (this.model.genre === '' ? undefined : this.model.genre);
            const onlyFavoritesUid = (this.model.onlyFavorites && this.$store.state.user.loggedIn) ? this.$store.state.user.user!.uid : undefined;
            const order = this.model.searchOrder;
            return { genre, partialName, onlyFavoritesUid, order };
        },

        async searchProjects() : Promise<void> {
            this.state = State.Searching;
            await this.$store.dispatch('submissions/search', this.searchFilter());
            this.state = State.Searched;
        },

        async favorited(favorite: Favorite) : Promise<void> {
            if (favorite.value)
                await this.$store.dispatch('submissions/favorite', favorite.submissionId);
            else
                await this.$store.dispatch('submissions/unfavorite', favorite.submissionId);
        },

        isFavorite(submissionId: SubmissionId) : boolean | undefined {
            if (!this.$store.state.user.loggedIn)
                return undefined;
            return this.$store.state.submissions.favorites.includes(submissionId);
        },
    },

    mounted() : void {
        this.searchProjects();
    },
});
